/* eslint-disable camelcase */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { registerField } from 'core/forms';

import { Select } from 'uikit/selects';

import styles from '../styles/formFieldSequence.module.scss';

const defaultCompletionsMinOptionText = ({ min, total }) =>
  i18n.t('completions-min-option', { min, total });

const getCompletionsMinOptions = ({ activities, completionsMinOptionText }) => {
  const options = [{ id: 1, label: i18n.t('all'), value: 0 }];

  if (activities > 1) {
    // eslint-disable-next-line no-plusplus
    for (let minActivities = 1; minActivities < activities; minActivities++) {
      options.push({
        id: minActivities + 1,
        label: completionsMinOptionText({ min: minActivities, total: activities }),
        value: minActivities,
      });
    }
  }

  return options;
};

const FormFieldSequence = ({
  fieldId,
  schema: {
    activities,
    completionsMinOptionText = defaultCompletionsMinOptionText,
    controlModeOptions,
  },
  updateField,
  value = { control_mode: '', completions_min: 0 },
}) => {
  const completionsMinOptions = getCompletionsMinOptions({ activities, completionsMinOptionText });

  const handleOnSelect = (field, newValue) => {
    if (field === 'control_mode') {
      if (newValue === 'choice') {
        return updateField({ control_mode: newValue, completions_min: 0 });
      }

      return updateField({ control_mode: newValue });
    }

    return updateField({ ...value, [field]: newValue });
  };

  return (
    <div className={styles.element} id={fieldId}>
      <Select
        id={`${fieldId}-control-mode`}
        onChange={(option) => handleOnSelect('control_mode', option.value)}
        options={controlModeOptions}
        value={controlModeOptions.find((option) => value?.control_mode === option.value)}
      />
      {value?.control_mode === 'choice' && (
        <Select
          id={`${fieldId}-completions-min`}
          onChange={(option) => handleOnSelect('completions_min', option.value)}
          options={completionsMinOptions}
          value={completionsMinOptions.find((option) => value?.completions_min === option.value)}
        />
      )}
    </div>
  );
};

FormFieldSequence.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    activities: PropTypes.number.isRequired,
    completionsMinOptionText: PropTypes.func,
    controlModeOptions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  value: PropTypes.shape({
    control_mode: PropTypes.string,
    completions_min: PropTypes.number,
  }),
};

registerField('Sequence', memo(FormFieldSequence));

export default memo(FormFieldSequence);
